
const UP = 'up';
const DOWN = 'down';
const RIGHT = 'right';
const LEFT = 'left';
let DIRECTION = '';
const TouchEvents = Marionette.Behavior.extend({
    defaults: {
        direction: null, // Set a default value for the variable
    },
    events: {
        'touchstart @ui.toggleMobileView': 'handleTouchStart',
        'touchend @ui.toggleMobileView': 'handleTouchEnd',
    },
    initialize: function () {
        this.direction = this.options.direction; //direction of the swipe
        this.targetClass = this.options.targetClass; //targetClass to watch for event
        // Assign the passed variable to a behavior property
    },
    handleTouchStart: function (e) {
        // Do something when touchstart event occurs
        this.startChangedObj = e.changedTouches[0];
    },

    handleTouchEnd: function (e) {
        // Do something when touchend event occurs
        if(this.view.$el){
            this.element =this.view.$el.find(this.targetClass);
            this._handleTouchEvent(e, this.element, this.direction,  (isOpen)=>{this.isVisible = isOpen});
        }
    },
    _handleTouchEvent: function (e, targetClass, direction, callback) {
        //const gestureZone = event.target;
        let touchstart = 0;
        let touchend = 0;

        //gets the start touch screen Y 
        if (direction === UP || direction === DOWN) {
            touchstart = this.startChangedObj.screenY;
            touchend = event.changedTouches[0].screenY;
        } else {
            //gets the start touch screen X
            touchstart = this.startChangedObj.screenX;
            touchend = event.changedTouches[0].screenX;
        }
        // this._getDirectionFromAxis(ixYAxis, touchstart, touchend)
        this._handleGesture(targetClass, touchstart, touchend, callback);
    },


    _handleGesture: function (element, touchstart, touchend, callback) {
        //swiping-up
        if (touchend < touchstart) {
            callback(true);
            element.addClass('visible');
        }
        //swiping-down
        if (touchend > touchstart) {
            callback(false);
            element.removeClass('visible');
        }
        //tapping
        if (touchend === touchstart) {
            element.toggleClass('visible');
             if(element.hasClass('visible'))
                callback(true)
             else    
                callback(false)
        }

    }

});

module.exports = TouchEvents;